"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingStatus = exports.ScoreboardStatus = exports.PeriodType = exports.BookingStatus = exports.MarketOutcomeStatus = exports.MarketStatus = exports.EventStatus = void 0;
var EventStatus;
(function (EventStatus) {
    EventStatus["Draft"] = "Draft";
    EventStatus["Prematch"] = "Prematch";
    EventStatus["Live"] = "Live";
    EventStatus["Ended"] = "Ended";
    EventStatus["Suspended"] = "Suspended";
    EventStatus["Settled"] = "Settled";
    EventStatus["NotActive"] = "NotActive";
})(EventStatus || (exports.EventStatus = EventStatus = {}));
var MarketStatus;
(function (MarketStatus) {
    MarketStatus["Open"] = "Open";
    MarketStatus["OnHold"] = "OnHold";
    MarketStatus["WaitingForResult"] = "WaitingForResult";
    MarketStatus["Settled"] = "Settled";
    MarketStatus["Refund"] = "Refund";
})(MarketStatus || (exports.MarketStatus = MarketStatus = {}));
var MarketOutcomeStatus;
(function (MarketOutcomeStatus) {
    MarketOutcomeStatus["Active"] = "Active";
    MarketOutcomeStatus["NotHappened"] = "NotHappened";
    MarketOutcomeStatus["Happened"] = "Happened";
    MarketOutcomeStatus["NotActive"] = "NotActive";
})(MarketOutcomeStatus || (exports.MarketOutcomeStatus = MarketOutcomeStatus = {}));
var BookingStatus;
(function (BookingStatus) {
    BookingStatus["Buyable"] = "Buyable";
    BookingStatus["Bookable"] = "Bookable";
    BookingStatus["Booked"] = "Booked";
    BookingStatus["Unavailable"] = "Unavailable";
})(BookingStatus || (exports.BookingStatus = BookingStatus = {}));
var PeriodType;
(function (PeriodType) {
    PeriodType["RegularPeriod"] = "RegularPeriod";
    PeriodType["Overtime"] = "Overtime";
    PeriodType["Penalties"] = "Penalties";
    PeriodType["Other"] = "Other";
})(PeriodType || (exports.PeriodType = PeriodType = {}));
var ScoreboardStatus;
(function (ScoreboardStatus) {
    ScoreboardStatus["Not_Started"] = "Not_Started";
    ScoreboardStatus["Live"] = "Live";
    ScoreboardStatus["Suspended"] = "Suspended";
    ScoreboardStatus["Ended"] = "Ended";
    ScoreboardStatus["Closed"] = "Closed";
    ScoreboardStatus["Cancelled"] = "Cancelled";
    ScoreboardStatus["Delayed"] = "Delayed";
    ScoreboardStatus["Interrupted"] = "Interrupted";
    ScoreboardStatus["Postponed"] = "Postponed";
    ScoreboardStatus["Abandoned"] = "Abandoned";
    ScoreboardStatus["Unknown"] = "Unknown";
    ScoreboardStatus["MatchAboutToStart"] = "MatchAboutToStart";
})(ScoreboardStatus || (exports.ScoreboardStatus = ScoreboardStatus = {}));
var ReportingStatus;
(function (ReportingStatus) {
    ReportingStatus["Suspended"] = "Suspended";
    ReportingStatus["NotAvailable"] = "NotAvailable";
    ReportingStatus["Live"] = "Live";
    ReportingStatus["Unknown"] = "Unknown";
})(ReportingStatus || (exports.ReportingStatus = ReportingStatus = {}));
//# sourceMappingURL=trading.js.map